import React from 'react'
import { HippostdHtml } from './HippostdHtml.jsx'
import './CtiBlogKeyPointsCompound.css'
/*
"keypoints": {
    "name": "cti:keypoints",
    "displayName": "cti:keypoints",
    "title": "",
    "content": { "contentType": "hippostd:html", "value": "" },
    "contentType": "cti:BlogKeyPointsCompound"
  },

*/

export const CtiBlogKeyPointsCompound = (props) => {
  const { keypoints } = props
  return keypoints.title && keypoints.content?.value ? (
    <div className="CtiBlogKeyPointsCompound u-decoBackgroundNeutral05">
      <div className="u-sizeConstrained u-sizeConstrainedNarrow u-paddingVert12gu">
        <div className="u-marginBottom2gu keyPoints-title">
          {keypoints.title && (
            <h2 className="u-textColorDefault ">{keypoints.title}</h2>
          )}
          <div className="u-marginTop2gu u-bgColorBrandExtraLight keyPoints-title-underline"></div>
        </div>
        {keypoints.content?.value && (
          <HippostdHtml
            value={keypoints.content.value}
            className="u-marginTop2gu"
          />
        )}
      </div>
    </div>
  ) : null
}
